import { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import introAnimation from '../introAnimation';

/* Full-screen intro splash. Plays the Lottie once, then hands off to the page.
   `playKey` changes to replay it (dev "↻ intro" button). */
export default function IntroSplash({ visible, playKey, onEnd }) {
  const holderRef = useRef(null);
  const endedRef = useRef(false);

  useEffect(() => {
    if (!visible) return undefined;
    endedRef.current = false;
    const end = () => {
      if (endedRef.current) return;
      endedRef.current = true;
      onEnd();
    };
    let anim = null;
    try {
      anim = lottie.loadAnimation({
        container: holderRef.current,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: introAnimation,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
      });
      anim.addEventListener('complete', end);
    } catch (e) {
      setTimeout(end, 300);
    }
    const failsafe = setTimeout(end, 9000);
    return () => {
      clearTimeout(failsafe);
      /* keep the last frame on screen while the splash fades out */
      if (anim) setTimeout(() => anim.destroy(), 600);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, playKey]);

  return (
    <div className={'gfg-splash' + (visible ? '' : ' gfg-gone')}>
      <div className="gfg-introHolder" ref={holderRef} key={playKey} />
      <button className="gfg-skip" onClick={onEnd}>Skip intro</button>
    </div>
  );
}
